module.exports = __webpack_public_path__ + "img/logo-agec-campus.041efdba.svg";